var map = {
	"./1.png": "4e3e",
	"./1a.png": "b1f9",
	"./2.png": "48764",
	"./2a.png": "288a",
	"./3.png": "c644",
	"./3a.png": "4290",
	"./4.png": "08e9",
	"./4a.png": "7e40",
	"./5.png": "f95f",
	"./5a.png": "838e",
	"./error.png": "4e8a",
	"./logo_wpxe.png": "87e2",
	"./success.png": "138e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5140";